<template>
  <div
    class="report-view"
  >
    <div
      v-for="column in layoutColumns"
      :key="column"
    >
      <div
        v-for="(row, index) in layoutRows"
        :key="index"
      >
        <q-card
          v-if="view.viewData[row][column] && view.viewData[row][column].type === 'html'"
          class="col report-element full-width"
          :class="index === 0 ? 'q-mb-lg' : 'q-my-lg'"
          dense
          flat
          bordered
          style="page-break-after: always;"
        >
          <q-card-section
            class="q-pa-none"
          >
            <!-- eslint-disable vue/no-v-html -->
            <div
              class="q-mx-auto"
              v-html="view.viewData[row][column].html"
            />
            <!-- eslint-enable vue/no-v-html -->
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ReportViewMultiples',
  props: {
    view: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    layoutRows () {
      return _.times(this.view.layout.rows, (index) => { return index })
    },
    layoutColumns () {
      return _.times(this.view.layout.columns, (index) => { return index })
    },
    shouldShowFilter () {
      return this.showFilter
    },
    paginate () {
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
</style>
